import React, { useEffect, useState } from 'react';
import { formatDate } from '@fullcalendar/core/index.js';
import { Button, Modal } from 'antd';
import { t } from 'i18next';

export function TimeslotModal({
  showModal,
  closeModal,
  selectedDate,
  onSelectedDateChange,
  onTimeslotChange,
  timeslots
}) {
  const [availableTimeSlots, setavailableTimeSlots] = useState();

  useEffect(() => {
    setavailableTimeSlots(timeslots);
  }, [timeslots]);

  function onTimeSlotSelect(value) {
    onTimeslotChange(value);
    onSelectedDateChange(selectedDate);
    closeModal();
  }

  return (
    <Modal
      okText={t('steps.deliveryMoment.address.modal.ok')}
      title={t('steps.deliveryMoment.calendar.modal.title')}
      open={showModal}
      centered={true}
      onCancel={closeModal}
      footer={[
        <Button key="back" onClick={closeModal}>
          {t('steps.deliveryMoment.address.modal.cancel')}
        </Button>
      ]}>
      {selectedDate && (
        <h4 className="text-base font-medium">
          {t('steps.deliveryMoment.calendar.modal.subTitle')}{' '}
          <b>
            <span className="text-[#2E8634]">
              {formatDate(selectedDate, {
                weekday: 'long',
                day: 'numeric',
                year: 'numeric',
                month: 'long',
                locale: t('type')
              })}
            </span>
          </b>
          ?
        </h4>
      )}

      <div className="grid grid-cols-2 gap-2 my-2">
        {availableTimeSlots &&
          availableTimeSlots.map((timeslot, index) => (
            <button
              key={index}
              onClick={() => onTimeSlotSelect(timeslot.split(' ')[0])}
              className="hover:bg-[#a9d9a5] rounded-md py-3 px-3 text-sm font-semibold uppercase cursor-pointer border-2 mr-2 mb-2">
              {timeslot}
            </button>
          ))}
      </div>
    </Modal>
  );
}
